import { Descriptions, Skeleton, Space, Tag, Typography } from "antd";
import { useTranslation } from "react-i18next";

import { type CampaignMessageComposeFormModel } from "./types";

const { Text, Link, Paragraph } = Typography;

export const ComposeCampaignConfirm = ({
  model,
  condition,
  tags,
}: {
  model: CampaignMessageComposeFormModel | null;
  tags?: string[];
  condition: "hasTag" | "notHasTag" | false;
}) => {
  const { t } = useTranslation("campaigns");
  if (!model) {
    return <Skeleton active paragraph={{ rows: 10 }} />;
  }

  return (
    <Descriptions title="Szczegóły kampanii" bordered column={1} className="my-4">
      <Descriptions.Item label={t("popup.form.visualType")}>
        <Text>{model.visualType === "modal" ? "Modal" : "Bottom sheet"}</Text>
      </Descriptions.Item>
      {condition ? (
        <Descriptions.Item label="Warunek wysłania kampanii">
          <Text>{condition === "notHasTag" ? "Nie posiada taga: " : "Posiada tag: "}</Text>
          <Space direction="horizontal">
            {tags?.map((tag) => (
              <Tag key={tag}>{tag}</Tag>
            ))}
          </Space>
        </Descriptions.Item>
      ) : null}
      <Descriptions.Item label="Tytuł">
        <Text strong>{model.message.title}</Text>
      </Descriptions.Item>
      <Descriptions.Item label="Opis" labelStyle={{ width: 250 }}>
        <Paragraph
          className="whitespace-pre-wrap"
          ellipsis={{
            rows: 6,
            expandable: "collapsible",
            symbol: (open) => (open ? "mniej" : "więcej"),
          }}
        >
          {model.message.description}
        </Paragraph>
      </Descriptions.Item>
      <Descriptions.Item label="Link">
        {model.message.ctaLink ? (
          <Link href={model.message.ctaLink} target="_blank" copyable>
            {model.message.ctaLink}
          </Link>
        ) : (
          "-"
        )}
      </Descriptions.Item>
      <Descriptions.Item label="Tekst dla CTA">
        <Text underline>{model.message.ctaText || "-"}</Text>
      </Descriptions.Item>
      {model.message.pushTitle ? (
        <Descriptions.Item label="Tytuł powiadomienia PUSH">
          <Text>{model.message.pushTitle}</Text>
        </Descriptions.Item>
      ) : null}
      {model.message.pushDescription ? (
        <Descriptions.Item label="Opis powiadomienia PUSH">
          <Text>{model.message.pushDescription}</Text>
        </Descriptions.Item>
      ) : null}
      <Descriptions.Item label="Data wysłania">
        <Text underline={model.sendImmediately} strong type={model.sendImmediately ? "danger" : undefined}>
          {model.sendImmediately
            ? "Natychmiast"
            : model.sentDate
                ?.set("hour", model.sentTime.get("hour"))
                .set("minute", model.sentTime.get("minute"))
                .format("DD.MM.YYYY HH:mm")}
        </Text>
      </Descriptions.Item>
      <Descriptions.Item label={t("popup.form.deadlineAt")}>
        <Text>{model.deadlineAt ? model.deadlineAt.format("DD.MM.YYYY HH:mm") : "-"}</Text>
      </Descriptions.Item>
    </Descriptions>
  );
};
